import React, { useState, useEffect } from "react";
import  ActionCenter  from "./ActionCenter";
import RenderDeliveryGroupMapping from './RenderDeliveryGroupMapping'

import { useLocation, useNavigate } from "react-router-dom";
import { Msg200or201, Msg204, Msg400, Msg401, Msg409, Msg403, Msg500 } from '../../Messages/Messages';
import { decryptData } from "../../../utils/storageCrypto";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";



const steps = [
  "Delivery Group",
  "Bill Generated",
  "Invoices Generated",
  "Waiting for Delivery",
];


/* ================= MAIN COMPONENT ================= */
const OrderFullfillmentFlow = () => {
  const navigate = useNavigate()
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [deliveryGroup, setDeliveryGroup] = useState();
  const [activeStep, setActiveStep] = useState(1);
  const location = useLocation();
  const {delivery_group_id, order_data, all_delivery_groups }= location.state || ''
  console.log('delivery_group_id', delivery_group_id);
  console.log('order_data', order_data);
  console.log('all_delivery_groups', all_delivery_groups);
 const [showPopup, setShowPopup] = useState(false);
 const [popupType, setPopupType] = useState("");
 const [popupMessage, setPopupMessage] = useState("");
 const [isGeneratingInvoice, setIsGeneratingInvoice] = useState(false);
 const [isInitiateBillingLoading, setIsInitiateBillingLoading] = useState(false);
 const [activeDeliveryGroupId, setActiveDeliveryGroupId] = useState(delivery_group_id);
 const [isStepLoading, setIsStepLoading] = useState(false);
 const [isDeliveryGroupLoading, setIsDeliveryGroupLoading] = useState(false);
 const [isRefreshing, setIsRefreshing] = useState(false);

   const FetchOrderbyID = async () => {
    try {
       setIsDeliveryGroupLoading(true); 
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


      const response = await fetch(
        `${fetchUrl}customer/salesorder/get-delivery-group-details?delivery_group_id=${activeDeliveryGroupId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        }
      );
      //console.log('response', response)
      const data = await response.json();
      console.log(' Order Data:', data);
      setDeliveryGroup(data?.data || []);
      console.log('Delivery Group set to:', data?.data || []);
    } catch (error) {
      console.error('Error fetching order data:', error);
      setDeliveryGroup([]);
    }finally {
      setIsDeliveryGroupLoading(false);
    }
  };

  useEffect(() => {
  if (activeDeliveryGroupId) {
    FetchOrderbyID();
  }
}, [activeDeliveryGroupId]);

      useEffect(() => {
     if(deliveryGroup){
    if(deliveryGroup.invoice_status === 'Invoice Generated'){
      if(deliveryGroup.delivery_group_status !== 'Waiting for Delivery Schedule'){
       setActiveStep(4)
      }else{
      setActiveStep(3)
      }     
      }else if(deliveryGroup.billing_status === 'Billed'){
     setActiveStep(2)
    }else{
    setActiveStep(1)
    }
     }      
    }, [deliveryGroup]);

    useEffect(() => {
  setIsStepLoading(true);

  const timer = setTimeout(() => {
    setIsStepLoading(false);
  }, 400); // loader duration

  return () => clearTimeout(timer);
}, [activeStep]);

   
    const handleGenerateBill = async () => {
  // Ensure we have at least one selected group
  if (!deliveryGroup ) {
    setPopupType('400');
    setPopupMessage("delivery Group not available.");
    setShowPopup(true);
    return;
  }
 const ids = [deliveryGroup._id]
  try {
      setIsInitiateBillingLoading(true);
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}bill/award-order-and-generate-bills`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({
          delivery_group_ids: ids, 
        }),
      }
    );

    console.log("body sent:", { delivery_group_ids: ids });
    const data = await response.json();
    console.log("Generate Bill Response:", data);

   if (data.success) {
      setPopupType('200or201');
      setPopupMessage("Bill generated successfully!");
      setShowPopup(true);
       setTimeout(() => {
          setShowPopup(false);
        }, 1000); 
       FetchOrderbyID()
    } else {
      setPopupType('400');
      setPopupMessage(data.message || "Failed to generate bill");
      setShowPopup(true);
    }
  } catch (error) {
    console.error("Generate Bill Error:", error);
    setPopupType('500');
    setPopupMessage("Something went wrong. Try again!");
    setShowPopup(true);
  }finally {
    setIsInitiateBillingLoading(false);
  }
};

const handleGenerateInvoices = async () => {
  try {
    setIsGeneratingInvoice(true);

    if (!deliveryGroup?.sub_orders?.length) return;

    for (const subOrder of deliveryGroup.sub_orders) {
      const success = await handleGenerateInvoice(subOrder);
      if (!success) {
        throw new Error("Invoice generation failed");
      }
    }

    setPopupType("200or201");
    setPopupMessage("All invoices generated successfully");
    setShowPopup(true);

    setTimeout(() => {
      setShowPopup(false);
    }, 3000);

    FetchOrderbyID();
  } catch (error) {
    setPopupType("400");
    setPopupMessage("Failed to generate invoices");
    setShowPopup(true);
  } finally {
    setIsGeneratingInvoice(false);
  }
};


const handleGenerateInvoice = async (subOrder) => {
  try {
    const poId = subOrder?.purchaseorder_id;

    if (!poId) {
      console.error("No Purchase Order ID found for subOrder");
      return false;
    }

    const bodyPayload = {
      po_ids: [poId],
    };

    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}invoice/create-invoices-for-order-using-poids`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(bodyPayload),
      }
    );

    const data = await response.json();

    return data?.success === true;
  } catch (error) {
    console.error("Generate Invoice Error:", error);
    return false;
  }
};


const closePopup = () => {
    setShowPopup(false);
  };
  
const Retry = () => {
  // Implement retry logic, e.g., refetch data
  setShowPopup(false);
};

const BackToLoginPage = () => {
    console.log("Back To Login Page");
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };

const triggerLeftRefresh = async () => {
  try {
    setIsRefreshing(true);      
    await FetchOrderbyID();   
  } catch (e) {
    console.error("Refresh failed", e);
  } finally {
    setTimeout(() => {
      setIsRefreshing(false);   
    }, 800);
  }
};

  

  return (
  <div className="flex h-screen">

    <div className="relative flex-1 h-full flex flex-col min-w-0"> 
     {isRefreshing ? (
    <div className="absolute inset-0 z-50 flex justify-center items-start pt-20 bg-white/70 backdrop-blur-sm">
      <div className="flex space-x-2">
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.3s' }} />
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }} />
      </div>
    </div>
   ) : (
    <>
    {/* ===== MAIN CONTENT ===== */}
    <div className="flex-1 overflow-y-auto relative">

      {/* ===== FIXED HEADER (ORDER INFO + STEPPER) ===== */}
      <div className="sticky top-0 z-30  border border-gray-200 rounded-md mx-6 mt-4 bg-gray-50 mb-4">
  <div className="flex items-center text-sm text-gray-700">

        <div className="mr-2 ml-4 cursor-pointer ">
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className="text-gray-700 text-md hover:text-black"
                  onClick={() => navigate("/bb/app/home", { state: { activeTab: "orders" } })} 
                />
              </div>

        {/* ===== ORDER INFO BAR ===== */}
        <div className="px-6 py-3">
          <div className="flex items-center text-sm text-gray-700">

            {/* ORDER NUMBER */}
            <div className="pr-6">
              <p className="text-xs text-gray-500">Order Number</p>
              <p className="font-semibold mt-1">{order_data.orderNumber}</p>
            </div>

            <div className="h-8 w-px bg-gray-200 mx-6" />

            {/* STATUS */}
            <div className="pr-6">
              <p className="text-xs text-gray-500">Status</p>
              <p className="font-semibold mt-1">{order_data.status}</p>
            </div>

            <div className="h-8 w-px bg-gray-200 mx-6" />

            {/* CREATED DATE */}
            <div>
              <p className="text-xs text-gray-500">Created At</p>
              <p className="font-semibold mt-1">
                {(() => {
                  const orderDate = new Date(order_data.orderDate);
                  const date = orderDate.toLocaleDateString("en-IN", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  });
                  const time = orderDate.toLocaleTimeString("en-IN", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  });
                  return `${date}, ${time}`;
                })()}
              </p>
            </div>
           <div className="h-8 w-px bg-gray-200 mx-6" />
            {Array.isArray(all_delivery_groups) && all_delivery_groups.length > 1 && (
  <div className="mt-3 flex gap-3 flex-wrap">
    {all_delivery_groups.map((dg) => (
      <button
        key={dg._id}
        onClick={() => setActiveDeliveryGroupId(dg._id)}
        className={`px-3 py-1 text-sm rounded-full border transition
          ${
            activeDeliveryGroupId === dg._id
              ? "bg-blue-600 text-white border-blue-600"
              : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
          }`}
      >
        {dg.delivery_group_number}
      </button>
    ))}
  </div>
)}

          </div>
        </div>
        </div>
        </div>

        {/* ===== STEPPER ===== */}
{/* <div className="relative px-4 py-4">


  <div className="absolute  w-1/2 inset-x-10 top-1/2 -translate-y-1/2 h-[2px] bg-gray-300" />

  <div
    className="absolute left-10  w-1/2 top-1/2 -translate-y-1/2 h-[2px] bg-blue-600 transition-all duration-300"
    style={{
      width:
        activeStep <= 1
          ? "0%"
          : `calc(${((activeStep - 1) / (steps.length - 1)) * 100}% )`,
    }}
  />


  <div className="relative flex justify-between z-10 mt-3">
    {steps.map((label, index) => {
      const step = index + 1;
      const isCompleted = step < activeStep;
      const isActive = step === activeStep;

      return (
        <div
          key={label}
          //onClick={() => setActiveStep(step)}
          className="flex flex-col items-center  flex-1"
        >
        
          <div
            className={`w-9 h-9 rounded-full flex items-center justify-center border transition-all duration-300
              ${
                isCompleted
                  ? "bg-blue-600 border-blue-600"
                  : isActive
                  ? "bg-white border-blue-600"
                  : "bg-white border-gray-300"
              }`}
          >
            {isCompleted ? (
              <svg
                className="w-4 h-4 text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            ) : (
              <span
                className={`text-xs font-semibold ${
                  isActive ? "text-blue-600" : "text-gray-400"
                }`}
              >
                {step}
              </span>
            )}
          </div>


          <p
            className={`mt-1 text-[11px] text-center leading-tight ${
              isActive || isCompleted
                ? "text-blue-600 font-medium"
                : "text-gray-400"
            }`}
          >
            {label}
          </p>
        </div>
      );
    })}
  </div>

</div>
 */}

<div className="sticky top-[80px] z-40 bg-white relative mb-6 mt-2">
  
  {/* ===== GRAY CONNECTOR LINE ===== */}
  <div
    className="absolute top-6 h-[2px] bg-gray-300 z-0"
    style={{
      left: `${50 / steps.length}%`,
      right: `${50 / steps.length}%`,
      width:
        steps.length > 1
          ? `calc(100% - ${100 / steps.length}%)`
          : "0%",
    }}
  />

  {/* ===== BLUE PROGRESS LINE ===== */}
  <div
    className="absolute top-6 h-[2px] bg-green-500 z-10 transition-all duration-500 ease-in-out"
    style={{
      left: `${50 / steps.length}%`,
      width:
        activeStep <= 1
          ? "0%"
          : `calc(
              ((100% - ${100 / steps.length}%)
              / ${steps.length - 1})
              * ${activeStep - 1}
            )`,
    }}
  />

  {/* ===== STEPS ===== */}
  <div className="flex justify-between relative z-20">
    {steps.map((label, index) => {
      const step = index + 1;
      const isCompleted = step < activeStep;
      const isActive = step === activeStep;

      return (
        <div
          key={label}
          className={`flex flex-col items-center flex-1 cursor-pointer ${
            step === 1 ? "-ml-6" : step === steps.length ? "ml-6" : ""
          }`}
        >
          {/* ===== CIRCLE ===== */}
          <div
            className={`w-12 h-12 rounded-full flex items-center justify-center shadow-md border-2 transition-all duration-300
              ${
                isCompleted
                  ? "bg-green-500 border-green-500 scale-110"
                  : isActive
                  ? "bg-white border-blue-700 shadow-lg scale-105"
                  : "bg-white border-gray-300 hover:border-gray-400"
              }`}
          >
            {isCompleted ? (
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            ) : (
              <span
                className={`font-bold text-sm ${
                  isActive ? "text-blue-600" : "text-gray-400"
                }`}
              >
                {step}
              </span>
            )}
          </div>

          {/* ===== LABEL ===== */}
          <p
            className={`mt-2 text-xs font-medium text-center transition-colors duration-300 ${
              isCompleted
  ? "text-green-600 font-semibold"
  : isActive
  ? "text-blue-600 font-semibold"
  : "text-gray-400"
            }`}

          >
            {label}
          </p>
        </div>
      );
    })}
  </div>
</div>




      

      {/* ===== STEP CONTENT ===== */}
      <div className="px-6 py-4 mb-2">
      {(isStepLoading || isDeliveryGroupLoading) && (
    <div className=" flex w-full  justify-center  bg-opacity-50 ">
    <div className=" flex space-x-2 w-full justify-center items-center h-20  ">
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.3s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }} />
    </div>
  </div>
  )}
{!isStepLoading && !isDeliveryGroupLoading && (
        <RenderDeliveryGroupMapping
        activeStep = {activeStep}
        deliveryGroup = {deliveryGroup}
        handleGetDg = {FetchOrderbyID}
         setShowPopup={setShowPopup}
    setPopupType={setPopupType}
    setPopupMessage={setPopupMessage}
        />
)}
      </div>

    {/* ===== STICKY ACTION BUTTON (BOTTOM-RIGHT INSIDE CONTENT) ===== */}
<div className="sticky bottom-14 flex justify-end z-30 pointer-events-none">
  <div className="pointer-events-auto">
   {activeStep === 1 && (
  <>
    {deliveryGroup?.billing_status === "Ready To Bill" ? (
      <span className="px-5 py-2 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-lg">
        Billing process initiated
      </span>
    ) /* : deliveryGroup?.billing_status === "Partially Billed" ? (
      <span className="px-5 py-2 text-sm font-medium text-amber-700 bg-amber-50 border border-amber-200 rounded-lg">
        Partial billing completed
      </span>
    )  */: (
      <button
        onClick={handleGenerateBill}
        disabled={isInitiateBillingLoading}
        className={`px-5 py-2.5 text-sm font-medium text-white rounded-lg shadow-lg transition
          ${
            isInitiateBillingLoading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-red-600 hover:bg-red-700"
          }`}
      >
        {isInitiateBillingLoading ? (
          <span className="flex items-center gap-2">
            <svg
              className="animate-spin h-4 w-4 text-white"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
            Initiating…
          </span>
        ) : (
          "Initiate Billing"
        )}
      </button>
    )}
  </>
)}


   {activeStep === 2 && deliveryGroup?.billing_status === "Billed" && deliveryGroup?.bill_accepted_status?.toLowerCase() === "accepted" && (
  <button
    onClick={handleGenerateInvoices}
    disabled={isGeneratingInvoice || showPopup}
    className={`px-5 py-2.5 text-sm font-medium text-white rounded-lg shadow-lg transition flex items-center justify-center gap-2
      ${
        isGeneratingInvoice
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-red-600 hover:bg-red-700"
      }`}
  >
    {isGeneratingInvoice ? (
      <>
        <svg
          className="animate-spin h-4 w-4 text-white"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
        Generating…
      </>
    ) : (
      "Generate Invoice"
    )}
  </button>
)}

{activeStep === 4 && (
  <button
    //onClick={handleNavigateToCreateDelivery}
    className={`px-5 py-2.5 text-sm font-medium text-white rounded-lg shadow-lg transition flex items-center
       justify-center gap-2 bg-red-600 hover:bg-red-700`}
    onClick={() => navigate('/bb/app/home', { state: { activeTab: 'orders' } })}>
   Next
  </button>
)}

  </div>
</div>


      

    </div>
    </>
    )}
    </div>
  

    {/* ===== ACTION CENTER ===== */}
    <aside className="sticky top-[10px] h-[calc(100vh-73px)] w-80 border-l p-4">
             <ActionCenter onViewClick={triggerLeftRefresh} 
                     onNewNotification={triggerLeftRefresh} />
           </aside>

   {/* Full-screen modals (errors, auth) - render directly because they have their own overlay */}
  {showPopup && (
  <div className="z-[999]">
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
    {popupType === '409' && <Msg409 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}

  </div>
);

};

export default OrderFullfillmentFlow;
